import { createContext, useContext } from 'react';
import { noop } from 'es-toolkit/compat';
import { isMobile, isMobileScreen } from '@rio-cloud/rio-uikit/DeviceUtils';
import type { ListMenuItem } from '@rio-cloud/rio-uikit/components/listMenu/ListMenuGroup';

import { STYLE_RIO, type ThemeMode } from './header/Themes';

export type UikitVersionEntry = {
    id: string;
    label: string;
    path: string;
    url: string;
    tag?: string;
};

export type UikitVersionsList = {
    latest_release: string;
    versions: UikitVersionEntry[];
};

type UikitContextType = {
    theme: string;
    themeMode: ThemeMode;
    hasDarkmode: boolean;
    onThemeChange: (style: string, mode?: ThemeMode) => void;
    isApplicationHeaderMobile: boolean;
    isMenuFlyMode: boolean;
    showMenu: boolean;
    onMenuIconClicked: () => void;
    onMenuOutsideClicked: (event: MouseEvent | TouchEvent) => void;
    selectedUikitVersion: string;
    versionsList: UikitVersionsList;
    startMenu: ListMenuItem[];
    foundationsMenu: ListMenuItem[];
    componentsMenu: ListMenuItem[];
    uiTemplateMenu: ListMenuItem[];
    utilitiesMenu: ListMenuItem[];
    internalMenu: ListMenuItem[];
};

export const UikitContext = createContext<UikitContextType>({
    theme: STYLE_RIO,
    themeMode: 'light',
    hasDarkmode: true,
    onThemeChange: noop,
    isApplicationHeaderMobile: false,
    isMenuFlyMode: false,
    showMenu: !(isMobile() || isMobileScreen()),
    onMenuIconClicked: noop,
    onMenuOutsideClicked: noop,
    selectedUikitVersion: '',
    versionsList: { latest_release: '', versions: [] },
    startMenu: [],
    foundationsMenu: [],
    componentsMenu: [],
    uiTemplateMenu: [],
    utilitiesMenu: [],
    internalMenu: [],
});

export const useUikitContext = () => useContext(UikitContext);
